import React from "react";

const urlLogoAccount = "https://account-logo.sankhya.com.br/sankhyaid-logo.png";

export default props => {
    return (
        <div style={props.style}>
            <img src={urlLogoAccount}/>
        </div>
    )
}
